import * as React from "react";
import {forwardRef} from "react";

import styles from './TextoGrupo.module.css';

import {InputText} from 'primereact/inputtext';
import TextoGrupoProps from './TextoGrupoProps';

const TextoGrupo = forwardRef((props: TextoGrupoProps, inputRef?: any) => {
    return (
        <>
            <div className={`${styles.espacamento} p-fluid grid`}>
                <div className={props.fullSize ? "field col-12 md:col-12": "field col-12 md:col-4"}>
                    <label className={styles.label} htmlFor={props.id}>{props.label}</label>

                    <div className="p-inputgroup flex-1">
                        <span className="p-inputgroup-addon">
                            &nbsp;&nbsp;&nbsp;&nbsp;{props.labelGrupo}&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <InputText id={props.id} value={props.value ? props.value : ''}
                                   ref={inputRef !== undefined ? inputRef : null}
                                   tooltip={props.tooltip ? props.tooltip : undefined}
                                   tooltipOptions={props.tooltipPosition ? {position: props.tooltipPosition} : undefined}
                                   aria-describedby={`${props.id}-message`}
                                   invalid={props.invalid}
                                   disabled={props.disabled}
                                   placeholder={props.placeholder}
                                   style={{width: `${props.size}`}}
                                   required={props.required}
                                   keyfilter={props.keyFilter}
                                   maxLength={props.maxLength === undefined ? 255 : props.maxLength}
                                   onBlur={props.onBlurHandler}
                                   onFocus={props.onFocusHandler}
                                   onChange={props.onChangeHandler}/>
                    </div>
                </div>
            </div>
        </>
    );
});

export default TextoGrupo;